<template>
  <a href="https://mctweb.co.uk" class="inline-flex items-center ml-2 transition duration-200" target="_blank">Website by:
    <span class="pl-3 font-bold">MCT Web</span>
    <img src="https://mctweb.co.uk/icon.png" class="w-12 h-12 ml-2 shadow-md" alt="MCT Web"></a>
</template>

<script>
export default {}
</script>

<style scoped>
</style>
